import { render, staticRenderFns } from "./sysconfig.vue?vue&type=template&id=0f1d213c"
import script from "./sysconfig.vue?vue&type=script&lang=js"
export * from "./sysconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports